import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { motion } from 'motion/react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = isHome
    ? [
        { label: 'Home', href: '#home' },
        { label: 'About', href: '#about' },
        { label: 'Products', href: '#products' },
        { label: 'Brands', href: '#brands' },
        { label: 'Services', href: '#services' },
        { label: 'Book Service', href: '/book-service' },
        { label: 'Contact', href: '#contact' },
      ]
    : [
        { label: 'Home', href: '/' },
        { label: 'About', href: '/#about' },
        { label: 'Products', href: '/#products' },
        { label: 'Brands', href: '/#brands' },
        { label: 'Services', href: '/services-repairs' },
        { label: 'Book Service', href: '/book-service' },
        { label: 'Contact', href: '/#contact' },
      ];

  const textColor = scrolled ? 'text-foreground-950' : 'text-background-50';
  const linkColor = scrolled
    ? 'text-foreground-700 hover:text-primary-500'
    : 'text-background-200 hover:text-background-50';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'shadow-sm' : 'bg-transparent'
      }`}
      style={{ backgroundColor: scrolled ? '#F5F0E8' : 'transparent' }}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="/" className="flex items-center gap-2.5 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/d59ba4ba4e5f160e4781d8b81f851394/f5735cd9a713fc9d715878d69c8293bc.png"
              alt="Ashok Telecom Logo"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className={`font-medium text-sm transition-colors cursor-pointer ${linkColor}`}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/services-repairs"
              className="bg-accent-500 hover:bg-accent-600 text-background-50 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Repairs
            </a>
            <a
              href="tel:+919964111963"
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`${textColor} text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden border-t border-background-200/70"
          style={{ backgroundColor: '#F5F0E8' }}
        >
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="block text-foreground-700 hover:text-primary-500 font-medium text-sm py-2 cursor-pointer"
              >
                {link.label}
              </a>
            ))}
            <a
              href="/services-repairs"
              onClick={() => setMobileOpen(false)}
              className="block bg-accent-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              Repairs
            </a>
            <a
              href="tel:+919964111963"
              onClick={() => setMobileOpen(false)}
              className="block bg-primary-500 text-background-50 px-5 py-2.5 rounded-full text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>
        </motion.div>
      )}
    </nav>
  );
}